export default __webpack_public_path__ + "static/media/my.21310d2e.svg";